import abo from '../shared/abo';
import address from '../shared/address';
import notes from '../shared/notes';
import rentalObject from '../shared/rentalObject';
import { user } from './user';

const profile = `
    abos {
        ${abo}
    }
    bankAccount {
        iban
        id
        name
    }
    billingAddress {
        ${address}
    }
    birthDate
    created
    firstName
    getCurrentAbo {
        ${abo}
    }
    ${notes}
    id
    lastName
    newsletter
    rentalObjects {
        ${rentalObject}
    }
    preferredLang
    preferredMail
    sales
    tenantCasesObjects {
        path
        id
        created
        caseId
        status
        type
        rentalObject {
            address {
                apartmentNumber
                city
                country
                district
                firstName
                houseNumber
                lastName
                postalCode
                streetName
            }
        }
    }
    user {
        ${user}
    }
`;

export default profile;
